import { RouterModule, Routes } from "@angular/router";

import { DetalheCursoComponent } from "./detalhe-curso.component";
import { SobreOProgramaComponent } from "./sobre-o-programa/sobre-o-programa.component";
import { DisciplinasComponent } from "./disciplinas/disciplinas.component";
import { CorpoDocenteComponent } from "./corpo-docente/corpo-docente.component";
import { ProcessoSeletivoComponent } from "./processo-seletivo/processo-seletivo.component";
import { MetaGuard } from "@ngx-meta/core";

export const DETALHE_CURSO_ROUTER: Routes = [
    {
        path: 'mestrado/:curso',
        component: DetalheCursoComponent,
        canActivate: [MetaGuard],
        children: [
            {
              path: '',
              redirectTo: 'sobre-o-programa',
              pathMatch: 'full',
            },
            {
              path: 'sobre-o-programa',
              component: SobreOProgramaComponent,
            },
            {
              path: 'disciplinas',
              component: DisciplinasComponent,
            },
            {
              path: 'corpo-docente',
              component: CorpoDocenteComponent,
            },
            {
              path: 'processo-seletivo',
              component: ProcessoSeletivoComponent,
            },
          ],
    },
];

export const DetalhesCursoRouter = RouterModule.forChild(DETALHE_CURSO_ROUTER);